import logger from '@eventbrite/client-logger';
import { RespondentType } from '../models/questions';
import { AppNamespace } from '../state/app';

export const createMockAppState: (
    overrides?: Partial<AppNamespace>,
) => AppNamespace = (overrides) => ({
    appVersion: 'appVersion',
    ebDomain: 'eventbrite.com',
    event: {
        id: 'eventId',
        organizer_id: 'organizer_id',
        survey_type: RespondentType.buyer,
    },
    isEventbriteTLD: true,
    locale: 'locale',
    featureFlags: {},
    defaultUserCountry: '',
    locales: [],
    request: {
        correlation_id: 'correlation_id',
        session_id: 'session_id',
        params: {},
    },
    useIosProfile: false,
    useAndroidProfile: false,
    ...overrides,
});

export const genericDynamicImportErrorHandler = (err: any) => {
    logger.error(err);

    if (process.env.NODE_ENV !== 'production') {
        throw err;
    }
    return null;
};
